<template>
  <form class="form-single" v-on:submit.prevent="verifyAndSubmit">
    <div class="row">
      <div class="col-1">
        <h3 class="title">SMTP</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-1-2">
        <div class="form-group">
          <label for>SMTP Server</label>
          <input
            type="text"
            v-model="smtp.server"
            class="form-control"
            placeholder="Ex: smtp.gmail.com"
          />
          <div class="message">{{ validation.firstError('smtp.server') }}</div>
        </div>
      </div>

      <div class="col-1-2">
        <div class="form-group">
          <label for>SMTP Port</label>
          <input type="text" v-model="smtp.port" class="form-control" placeholder="Opcional" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-1-2">
        <div class="form-group">
          <label for>SMTP User</label>
          <input
            name="smtpUser"
            type="text"
            v-model="smtp.user"
            class="form-control"
            placeholder="Ex: meu-email@gmail.com"
          />
          <div class="message">{{ validation.firstError('smtp.user') }}</div>
        </div>
      </div>
      <div class="col-1-2">
        <div class="form-group">
          <label for>SMTP Password</label>
          <input
            autocomplete="new-password"
            name="smtpPass"
            type="password"
            v-model="smtp.pass"
            class="form-control"
            placeholder="Ex: Senha de acesso ao meu-email@gmail.com"
          />
          <div class="message">{{ validation.firstError('smtp.pass') }}</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-1-2">
        <div class="form-group">
          <label for>E-mail Adress</label>
          <input
                  name="smtpEmail"
                  type="text"
                  v-model="smtp.email"
                  class="form-control"
                  placeholder="Ex: meu-email@gmail.com"
          />
          <div class="message">{{ validation.firstError('smtp.email') }}</div>
        </div>
      </div>
      <div class="col-1-2">
        <div class="form-group">
          <button
                  type="button"
                  class="button button-primary"
                  style="margin-top:25px"
                  v-on:click="sendEmailTest()"
          >
            Testar SMTP
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <button class="button button-success">Salvar</button>
    </div>
  </form>
</template>
<script>
import SimpleVueValidation from "simple-vue-validator";

const Validator = SimpleVueValidation.Validator;

export default {
  name: "smtp",
  props: ["smtp", "onSubmit", "checkSmtp"],
  data() {
    return {};
  },

  validators: {
    "smtp.server": function(value) {
      return Validator.value(value).required("Campo obrigatório.");
    },
    "smtp.user": function(value) {
      return Validator.value(value).required("Campo obrigatório.");
    },
    "smtp.pass": function(value) {
      return Validator.value(value).required("Campo obrigatório.");
    },
    "smtp.email": function(value) {
      return Validator.value(value).required("Campo obrigatório.");
    }
  },
  methods: {
    sendEmailTest() {
      this.checkSmtp({ smtp: this.smtp })
    },
    verifyAndSubmit() {
      this.$validate().then(success => {
        if (success) {
          this.onSubmit({ smtp: this.smtp });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Config/Avancado/SMTP.vue